import Dialog from '@mui/material/Dialog';
import {
  Alert,
  Box,
  Button,
  DialogContent,
  Snackbar,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { DocumentTableRow, DocumentTypes } from '../../models/documentHub';
import { useMutateDeleteDocument } from '../../api/documentHub';

interface DeleteDocumentModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  row: DocumentTableRow;
}

export const DeleteDocumentModal = (props: DeleteDocumentModalProps) => {
  const deleteMutation = useMutateDeleteDocument();
  const { open, setOpen, row } = props;
  const [showError, setShowError] = useState(false);

  const handleError = () => {
    setOpen(false);
    setShowError(true);
  };

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
  };

  const handleDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    deleteMutation.mutate(
      {
        documentName: row.documentName,
        documentType: row.folderKey as DocumentTypes,
      },
      {
        onSuccess: () => setOpen(false),
        onError: () => handleError(),
      }
    );
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={showError}
        autoHideDuration={6000}
        onClose={() => setShowError(false)}
      >
        <Alert severity="error">
          Somethig went wrong deleting the document
        </Alert>
      </Snackbar>
      <Dialog
        data-testid="delete-image-modal"
        className="delete-image-modal"
        open={open}
        onClose={handleClose}
        aria-labelledby="auth-dialog-title"
      >
        <Box className="container">
          <Button
            variant="transparent"
            className="close-btn"
            onClick={(event) => handleClose(event)}
            sx={{ color: 'white' }}
          >
            <CloseIcon sx={{ fill: '#49454F' }} />
          </Button>
          <DialogContent className="content">
            <Typography variant="h5" className="description-title">
              Delete Document?
            </Typography>
            <Button
              className="save-btn"
              disabled={deleteMutation.isPending}
              onClick={handleDelete}
              variant="contained"
            >
              {deleteMutation.isPending ? 'Deleteing...' : 'Delete'}
            </Button>
            <Button className="save-btn" onClick={handleClose}>
              Cancel
            </Button>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
